import type File from '../../interfaces/File';
import type { FileTag } from '../../interfaces/File';
import type Tag from '../../interfaces/Tag';

/** Catalog tags that are attached to the file and marked file-visible. */
export function getVisibleCatalogTagsForFile(file: Pick<File, 'tags'>, catalogTags: Tag[]): Tag[] {
  return (
    file.tags
      ?.map((tag: FileTag) => catalogTags.find((catalogTag) => catalogTag.id === tag.id))
      .filter((catalogTag): catalogTag is Tag => !!catalogTag && catalogTag.fileVisible) ?? []
  );
}
